module.exports = __webpack_public_path__ + "static/media/21ECLAC23.a832f712.jpg";